import { Component } from '@angular/core';

@Component({
  templateUrl: './dimap.component.html',
})

export class DimapComponent {

}
